import { useEffect, useRef } from "react";
import { Volume2 } from "lucide-react";

export const useActiveCue = (cues, cur) => {
  if (!cues?.length) return -1;
  let idx = -1;
  for (let i = 0; i < cues.length; i++) if (cues[i].start <= cur + 0.2) idx = i;
  return idx;
};

// Teleprompter: previous line faded, current line large, next line dim.
export const ReadAlong = ({ cues, active, started }) => {
  if (!cues?.length) return null;
  if (!started) return (
    <p data-testid="readalong-idle" className="text-white/60 text-base leading-relaxed max-w-xs mx-auto">
      Press play and read along as your coach guides you.
    </p>
  );
  const cur = cues[active] || null;
  const prev = active > 0 ? cues[active - 1] : null;
  const next = active + 1 < cues.length ? cues[active + 1] : null;
  const Line = ({ c, cls, testId }) => c ? (
    <p data-testid={testId} className={`transition-all duration-500 ${cls} ${c.sfx ? "italic" : ""}`}>
      {c.sfx && <Volume2 size={16} className="inline mr-1.5 -mt-1 text-turq" />}{c.text}
    </p>
  ) : <p className={cls}>&nbsp;</p>;
  return (
    <div className="w-full max-w-sm mx-auto space-y-5 min-h-[14rem] flex flex-col justify-center" data-testid="readalong">
      <Line c={prev} cls="text-white/35 text-base leading-snug" testId="readalong-prev" />
      <Line c={cur} cls={`font-serif text-[26px] leading-snug font-semibold ${cur?.sfx ? "text-turq" : "text-white"}`} testId="readalong-current" />
      <Line c={next} cls="text-white/45 text-base leading-snug" testId="readalong-next" />
    </div>
  );
};

// Full transcript with the active sentence highlighted and kept in view.
export const TranscriptList = ({ cues, transcript, active, onSeek }) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.querySelector("[data-active=true]")?.scrollIntoView({ block: "center", behavior: "smooth" });
  }, [active]);
  if (!cues?.length) return <div className="whitespace-pre-wrap text-lg leading-relaxed text-white/85">{transcript}</div>;
  return (
    <div ref={ref} className="space-y-3">
      {cues.map((c, i) => (
        <button key={`${c.start}-${c.text.slice(0, 12)}`} data-testid={`transcript-line-${i}`} data-active={i === active} onClick={() => onSeek(c.start)}
          className={`block w-full text-left rounded-xl px-3 py-2 transition-colors ${
            i === active ? "bg-white/15 text-white font-semibold" : i < active ? "text-white/45" : "text-white/75"} ${c.sfx ? "italic text-turq/80" : ""}`}>
          <span className={c.sfx ? "text-base" : "text-lg leading-relaxed"}>{c.sfx && <Volume2 size={15} className="inline mr-1.5 -mt-0.5" />}{c.text}</span>
        </button>
      ))}
    </div>
  );
};
